import { useMutation, useQueryClient } from 'react-query';
import request from '../../../../../../helpers/request';
import { fetchRequestbyId } from '../queries/fetchRequestById';

const changeWarrantyState = async ({ requestId, garantyId }) => {
  const res = await request.put(
    `Warranty/set_warranty/${requestId}`,
    garantyId,
    'Не удалось изменить гарантийный статус заявки',
    'Error'
  );

  return res;
};

const requestSetAddress = async ({ requestId, values }) => {
  const res = await request.put(
    `/Request/set_address/${requestId}`,
    values,
    'Не удалось изменить мастера и исполнителя'
  );

  return res;
};

const putWarrantyState = async ({ requestId, values }) => {
  const formData = new FormData();

  Object.entries(values).forEach(([key, value]) => {
    formData.append([key], value);
  });

  const res = await request.put(
    `/Warranty/set_state/${requestId}`,
    formData,
    'Не удалось сохранить документ',
    'Error'
  );

  return res;
};

export const useWarrantyStateChange = ({ onSuccess }) => {
  const queryClient = useQueryClient();

  const changeMutation = useMutation(changeWarrantyState, {
    onSuccess: async (
      res,
      { requestId, garantyId, addressValues, warrantyDocValues }
    ) => {
      if (res !== 'Error') {
        let hasNewWarrantyDoc = false;

        const promises = [
          Boolean(addressValues) &&
            requestSetAddress({ requestId, values: addressValues }),
          Boolean(warrantyDocValues) &&
            putWarrantyState({
              requestId,
              values: { ...warrantyDocValues, newState: garantyId },
            }).then((result) => {
              if (result !== 'Error') {
                hasNewWarrantyDoc = true;
              }
            }),
        ];

        await Promise.allSettled(promises);

        const updatedRequest = await fetchRequestbyId({
          queryClient,
          requestId,
        });

        if (updatedRequest && typeof onSuccess === 'function') {
          onSuccess({ updatedRequest, hasNewWarrantyDoc });
        }
      }
    },
  });

  return {
    change: changeMutation.mutateAsync,
    loading: changeMutation.isLoading,
  };
};
